<template>
  <header class="bg-white-1 q-px-lg q-pt-md q-pb-sm shadow3">
    <div class="text-heading-1 text-secondary-2">{{ quickView.name }}</div>

    <Grid gaf="column" justify-content="space-between" class="q-pb-sm q-mt-sm">
      <Grid gtc="auto auto" align-items="start" gap="0 var(--r-space-xxl)" class="text-secondary-1">
        <Grid gaf="column" justify-content="start" align-items="center" gap="var(--r-space-sm)">
          <div class="text-body-1">Period:</div>

          <div class="text-body-4">
            {{ formatDateForLocale(quickView.start_date) }} - {{ formatDateForLocale(quickView.end_date) }}
          </div>
        </Grid>

        <Grid gaf="column" justify-content="start" align-items="center" gap="var(--r-space-sm)">
          <div class="text-body-1">Publisher:</div>

          <div v-if="quickView.publisher" class="text-body-4">{{ quickView.publisher.name }}</div>
          <span v-else class="text-body-3 text-grey3">N/A</span>
        </Grid>

        <Grid gaf="column" justify-content="start" align-items="center" gap="var(--r-space-sm)">
          <div class="text-body-1">Owner:</div>

          <div v-if="quickView.owner" class="text-body-4">{{ quickView.owner.name }}</div>
          <span v-else class="text-body-3 text-grey3">N/A</span>
        </Grid>

        <Grid gaf="column" justify-content="start" align-items="center" gap="var(--r-space-sm)">
          <div class="text-body-1">Vendor:</div>

          <div v-if="quickView.vendor" class="text-body-4">{{ quickView.vendor.name }}</div>
          <span v-else class="text-body-3 text-grey3">N/A</span>
        </Grid>
      </Grid>

      <Grid class="text-right">
        <div class="text-heading-1 text-secondary-1">{{ quickView.currency }} {{ formatPrice(quickView.price) }}</div>

        <div class="text-heading-5 text-secondary-1">
          Forecasted: {{ formatPrice(quickView.forecasted_price) || 'N/A' }}
        </div>
      </Grid>
    </Grid>
  </header>
</template>

<script>
export default {
  props: {
    quickView: Object
  }
}
</script>

<style lang="scss" scoped>
header {
  border-top: 1px solid var(--r-white-4);
  border-left: 1px solid var(--r-white-4);
  z-index: 1;
}
</style>
